module.exports = __webpack_public_path__ + "img/ring_r_e_0_0@3x.529a0a2a.png";